import React, { useState } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./show-hide-panel.scss";
import { IconChevronDown16 } from "../Icons/Icons";

const ShowHidePanel = ({
  id,
  headingLevel,
  headingContent,
  className,
  showLabel,
  hideLabel,
  children,
  isExpanded,
}) => {
  const [expanded, setExpanded] = useState(!!isExpanded);
  const classes = classnames(
    "show-hide-panel",
    {
      "show-hide-panel--expanded": expanded,
    },
    className
  );
  const controlId = `${id}-control`;
  const panelId = `${id}-panel`;
  const Heading = headingLevel;
  return (
    <div id={id} className={classes}>
      <Heading>
        <button
          id={controlId}
          aria-controls={panelId}
          aria-expanded={expanded ? "true" : "false"}
          className="show-hide-panel__control"
          onClick={() => setExpanded(!expanded)}
        >
          <span className="show-hide-panel__heading">{headingContent}</span>
          <span className="show-hide-panel__status">
            {expanded ? hideLabel : showLabel}{" "}
            <IconChevronDown16 className="show-hide-panel__chevron" />
          </span>
        </button>
      </Heading>
      {expanded && (
        <div
          key="content"
          id={panelId}
          className="show-hide-panel__content"
          role="region"
          aria-labelledby={controlId}
        >
          {children}
        </div>
      )}
    </div>
  );
};

ShowHidePanel.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  headingLevel: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  headingContent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  showLabel: PropTypes.string.isRequired,
  hideLabel: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  isExpanded: PropTypes.bool,
};

export default ShowHidePanel;
